(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var sections = document.querySelectorAll(
    'main[data-template="index"] .shopify-section, main[data-template="product"] .shopify-section'
  );

  if (!sections.length) return;

  if (!('IntersectionObserver' in window)) {
    sections.forEach(function (section) {
      section.classList.add('scroll-in');
    });
    return;
  }

  var revealed = new WeakSet();

  function reveal(section) {
    if (revealed.has(section)) return;
    revealed.add(section);
    section.classList.add('scroll-in');
  }

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          reveal(entry.target);
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0, rootMargin: '0px 0px 200px 0px' }
  );

  sections.forEach(function (section) {
    observer.observe(section);
  });

  // Safety net: never leave a section permanently invisible (slow devices,
  // unusual layouts, or an observer edge case). Force-reveal anything left
  // hidden after a short delay.
  setTimeout(function () {
    sections.forEach(reveal);
  }, 1500);
})();
